var _linearGradient;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchlinux(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.39377 0 0 .39375 978.35 416.981)",
    x1: 541.335,
    y1: 104.507,
    x2: 606.912,
    y2: 303.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "a",
    y2: 129.347,
    x2: 112.499,
    y1: 6.137,
    x1: 112.499,
    gradientTransform: "translate(287 -83)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.27450982
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00bdec",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#40bfde",
      stopOpacity: 1
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6e6e6e",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#4d4d4d",
      stopOpacity: 1
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1793d1",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M128 0c-11.395 27.937-18.313 46.237-31 73.344 7.778 8.245 17.338 17.812 32.844 28.656-16.67-6.86-28.034-13.729-36.531-20.875C77.076 115.005 51.621 163.246 0 256c40.563-23.418 72.008-37.862 101.313-43.375-1.254-5.404-1.924-11.278-1.876-17.375l.032-1.281c.644-25.994 14.17-45.982 30.187-44.625 16.018 1.357 28.488 23.537 27.844 49.531-.121 4.896-.69 9.6-1.656 13.969C184.834 218.517 215.982 232.897 256 256a14843.22 14843.22 0 0 1-21.688-40.094c-10.596-8.212-21.643-18.897-44.187-30.469 15.496 4.027 26.602 8.683 35.25 13.875C156.98 71.972 151.455 55.04 128 0z",
    transform: "matrix(.25 0 0 .25 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 0.16568047,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 36.09999847,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "M818.226 548.553c-41.181-55.895-50.727-100.945-53.145-111.7 21.968 50.668 21.818 51.29 53.145 111.7z",
    transform: "translate(-225.6 -146.736) scale(.33684)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.71416688,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M765.121 436.365c-1.068 2.626-2.075 5.186-3.061 7.608a2404.16 2404.16 0 0 1-3.155 7.7c-1.021 2.486-2.057 4.842-3.061 7.236-1.004 2.395-1.941 4.762-2.969 7.144-1.027 2.382-2.154 4.788-3.247 7.236a619.291 619.291 0 0 1-3.433 7.515c-1.199 2.593-2.456 5.348-3.803 8.164-.183.382-.371.82-.557 1.206 5.758 6.099 12.856 13.144 24.307 21.152-12.372-5.09-20.783-10.189-27.09-15.493-.329.671-.59 1.261-.928 1.948-1.247 2.585-2.584 5.145-3.99 7.979-.334.666-.582 1.267-.927 1.948-1.485 2.98-3.046 6.065-4.731 9.37-.335.65-.678 1.191-1.02 1.856-1.021 1.98-4.276 8.223-7.608 14.565-1.943 3.705-3.47 6.74-5.66 10.855-.62 1.182-1.898 3.548-2.226 4.174 24.12-13.577 50.143-33.299 97.412-16.42-2.367-4.484-4.636-8.665-6.68-12.618-2.043-3.953-3.896-7.632-5.659-11.132a866.36 866.36 0 0 1-4.917-9.927 671.282 671.282 0 0 1-4.267-8.906c-1.33-2.83-2.628-5.553-3.804-8.165a515.071 515.071 0 0 1-3.34-7.607c-1.066-2.471-2.063-4.92-3.061-7.329-.999-2.409-1.996-4.719-2.97-7.144-.423-1.055-.78-2.178-1.205-3.247-2.636-6.19-5.224-12.325-8.35-19.668z",
    transform: "translate(-225.6 -146.736) scale(.33684)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchlinux);
export default __webpack_public_path__ + "static/media/archlinux.5c494567d85f5ec7b8cb44d2daa0ebcd.svg";
export { ForwardRef as ReactComponent };